import { MEMBERSHIP_EVENTS } from "src/components/Person/events";
import { EVENTS } from "src/services/eventEmitter";

/** Events that change team structure, so cached insights aggregations go stale. */
export const INSIGHTS_STRUCTURE_EVENTS = [
  EVENTS.TEAM_OWNER_CHANGED,
  MEMBERSHIP_EVENTS.MEMBERSHIP_CHANGED,
  EVENTS.NEW_GROUP_ADDED,
  EVENTS.GROUP_REMOVED,
  EVENTS.INSIGHTS_WORKSPACE_CONFIG_CHANGED,
];
